import React, { useContext } from "react";
import { WebsiteContext } from "../../context/AppContext";
import ReviewCard from "../../common/ReviewCard";
import { motion } from "framer-motion";

const ReviewsComponent = () => {
  const { isMobileView } = useContext(WebsiteContext);

  const gridVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 50, damping: 15 },
    },
  };

  return (
    <div className={`reviews_section_wrapper ${isMobileView ? "mobile" : ""}`}>
      <motion.div
        className="reviews_header_container"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="reviews_main_title">Our Customers</h2>
        <p className="reviews_subtitle">
          Satisfaction Reveals <span className="heart_icon">❤</span>
        </p>
      </motion.div>

      <motion.div
        className="reviews_grid"
        variants={gridVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.div variants={cardVariants} className="review_card_wrapper">
          <ReviewCard
            mainText={
              "I have been using this taxi service for a few months now, and I have to say, it's been a great experience! The drivers are always on time, the cars are clean, and I feel safe every time I ride. Highly recommend it!"
            }
            reviewer={"— Sarah. D"}
          />
        </motion.div>

        <motion.div variants={cardVariants} className="review_card_wrapper">
          <ReviewCard
            mainText={
              "The ride was smooth and comfortable, and the fare was reasonable. I appreciate how professional and courteous the driver was. This will be my go-to taxi service from now on!"
            }
            reviewer={"— Naresh. S"}
          />
        </motion.div>

        <motion.div variants={cardVariants} className="review_card_wrapper">
          <ReviewCard
            mainText={
              "I hired a taxi for a city tour, and the experience was wonderful! My driver was knowledgeable about local attractions and made sure to take me to the best spots. It felt more like a personalized tour than just a ride. Highly recommended!"
            }
            reviewer={"— Sandhya. K"}
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ReviewsComponent;
